import React from 'react';
import { Button } from '@material-ui/core';
import useStyles from './styles';


const MapButton = ({handleClick}) => {
  const classes = useStyles();

  return (
    <Button
      color="primary"
      variant="outlined"
      className={`m-1 uppercase w-80 ${classes.mapButton}`}
      onClick={handleClick}
    >
      Map
    </Button>
  );
};

export default MapButton;
